import { fg } from '@confluence/feature-gating';
import { useContentType } from '@confluence/page-context';
import { ContentType } from '@confluence/content-types-utils/entry-points/contentTypeConstants';

export const useIsNewDanglingCommentExperienceEnabled = () => {
	const [contentType] = useContentType();

	return (
		contentType !== ContentType.DATABASE &&
		contentType !== ContentType.WHITEBOARD &&
		fg('confluence_frontend_new_dangling_comments_ux')
	);
};
